module.exports = __webpack_public_path__ + "img/132x132_shigong@2x.9bae9b55.png";